import React from 'react';

import { iconBaseProps, type IconProps } from './IconBase';

const BorderIcon: React.FC<IconProps> = props => (
  <svg {...iconBaseProps} {...props}>
    <path d="M4 21V4" />
    <path d="M4 5h14l-2 3.5 2 3.5H4" />
    <path d="M14 21v-6" />
  </svg>
);

export default BorderIcon;
